/**
 * 仓库管理 - 枚举定义
 * 
 * 本文件定义仓库相关的所有枚举类型
 * 
 * @module types/warehouse/enums
 * @category Warehouse - 仓库管理
 * 
 * @description
 * 包含的枚举类型：
 * - WarehouseType: 仓库类型（原料仓/半成品仓/成品仓/线边仓/不良品仓）
 * - WarehouseStatus: 仓库状态（启用/停用）
 * 
 * @backend-mapping
 * 对应后端文件：
 * - Model: backend/app/Modules/Warehouse/Models/Warehouse.php
 *   - TYPE_* 常量 → WarehouseType
 *   - STATUS_* 常量 → WarehouseStatus
 * 
 * @field-naming
 * - 枚举名：PascalCase（如 WarehouseType）
 * - 枚举值：与后端完全一致（包括大小写）
 * 
 * @important
 * ⚠️ 枚举值必须与后端 PHP 常量值完全一致
 * ⚠️ 不要自行修改枚举值，否则会导致前后端数据不匹配
 * 
 * @update-trigger
 * 当后端发生以下变更时需要同步更新：
 * - Model 新增/修改/删除类型常量
 * - Model 新增/修改/删除状态常量
 * 
 * @validation
 * 验证方式：
 * 1. 对照 Model 的常量定义
 * 2. 检查枚举值是否完全一致（包括大小写）
 * 3. 检查是否有遗漏或多余的枚举值
 * 4. 确认所有枚举都有中文注释
 * 
 * @example
 * ```typescript
 * import { WarehouseType, WarehouseStatus } from '@bayes-mes/shared';
 * 
 * const warehouseType: WarehouseType = WarehouseType.RAW;
 * const status: WarehouseStatus = WarehouseStatus.ACTIVE;
 * ```
 * 
 * @last-updated 2025-10-18
 * @author YSFL Team
 */

/**
 * 仓库类型枚举
 * 
 * 对应后端：Warehouse::TYPE_*
 */
export enum WarehouseType {
  /** 原料仓 */
  RAW = 'RAW',
  /** 半成品仓 */
  SEMI = 'SEMI',
  /** 成品仓 */
  PRODUCT = 'PRODUCT',
  /** 线边仓 */
  LINE = 'LINE',
  /** 不良品仓 */
  REJECT = 'REJECT',
}

/**
 * 仓库状态枚举
 * 
 * 对应后端：Warehouse::STATUS_*
 */
export enum WarehouseStatus {
  /** 停用 */
  INACTIVE = 0,
  /** 启用 */
  ACTIVE = 1,
}

